module.exports = global["$"] = require("-!/home/dani/kaiwa/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/jquery/dist/jquery.js
// module id = 296
// module chunks = 1